import SchoolRow from "./SchoolRow";
import { Icon } from "@iconify/react/dist/iconify.js";

const SchoolsTable = ({ schools, search }) => {
  if (!schools || schools.length === 0) {
    return (
      <div className="text-center py-5">
        <Icon
          icon={search ? "mdi:magnify-remove-outline" : "mdi:school-outline"}
          width="64"
          className="text-secondary-light mb-3"
        />
        <p className="text-secondary-light mb-1 fw-medium">
          {search
            ? "No se encontraron escuelas"
            : "No hay escuelas para mostrar"}
        </p>
        {search && (
          <p className="text-secondary-light text-sm">
            Intenta con otra búsqueda
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0" style={{ minWidth: "900px" }}>
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "220px" }}>Nombre</th>
            <th scope="col" style={{ minWidth: "100px" }}>Siglas</th>
            <th scope="col" style={{ minWidth: "140px" }}>Tipo</th>
            <th scope="col" style={{ minWidth: "130px" }}>Modalidad</th>
            <th scope="col" style={{ minWidth: "100px" }}>Estatus</th>
            <th scope="col" style={{ minWidth: "80px" }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {schools.map((school) => (
            <SchoolRow key={school.id} school={school} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SchoolsTable;
